import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CashbackRegionsEntity } from '../../domain/entities/CashbackRegionsEntity'

export class CashbackRegionsModel extends CashbackRegionsEntity {
  constructor(dataDto: CashbackRegionsEntity) {
    super()
    mapEntityProperties<CashbackRegionsEntity>(this, dataDto, {
      exclude: ['region', 'districts'],
      map: {
        regionId: dataDto.region?.id ?? dataDto.regionId,
        districtIds: dataDto.districts?.map((district) => district.id!).filter(Boolean) ?? []
      }
    })
  }
}
